import React, { useEffect } from "react";
import { TableCell, TableRow } from "../../../../design/table";
import { Task } from "../../../../models/Task";
import { Subtask } from "../../../../models/Subtask";
import { Button } from "../../../../design/button";
import { ArrowUpTrayIcon } from "@heroicons/react/20/solid";
import UploadFilesButton from "./UploadFilesButton";

interface DiscoveryRequestTaskListItemProps {
  subtask: Subtask;
}

const DiscoveryRequestTaskListItem: React.FC<
  DiscoveryRequestTaskListItemProps
> = ({ subtask }) => {
  return (
    <TableRow key={subtask._id}>
      <TableCell className={"font-bold"}>{subtask.title}</TableCell>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        <UploadFilesButton />
      </TableCell>
    </TableRow>
  );
};

export default DiscoveryRequestTaskListItem;
